import React, { useCallback, useEffect, useState } from "react";
import TableEmpresasContador from "../../organisms/contadoresEmpresas/TableEmpresasContador";
import { GET_ENTERPRISE_BY_ACCOUNTANT } from "../../../api/apiEmpresas";
import { useSession } from "../../../context/SessionContext";
import CardHeader from "../../atoms/CardHeader";
import Breadcrumb from "../../molecules/Breadcrumb";
import Fuse from "fuse.js";

const EmpresasContadorTemplate = () => {
    const [empresas, setEmpresas] = useState();
    const [filteredEmpresas, setFilteredEmpresas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ empresa: "", rfc: "" });
    const { user } = useSession();

    const getEnterprises = useCallback(async () => {
		try {
            setLoading(true);
			const enterpriseData = await GET_ENTERPRISE_BY_ACCOUNTANT(user?.roleInfo?.id);
            const sortedData = enterpriseData.sort((a, b) => a.id - b.id);
            setEmpresas(sortedData);
            setFilteredEmpresas(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	}, [user]);

    useEffect(() => {
        if (user?.roleInfo?.id) {
            getEnterprises();
        }
    }, [user, getEnterprises]);

    useEffect(() => {
        if (!empresas) return;

        const fuse = new Fuse(empresas, {
            keys: [
                { name: "name", weight: 0.5 },
                { name: "rfc", weight: 0.3 },
            ],
            threshold: 0.3,
        });

        const searchTerms = `${filters.empresa} ${filters.rfc}`.trim();

        if (searchTerms) {
            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredEmpresas(results);
        } else {
            setFilteredEmpresas(empresas);
        }
    }, [filters, empresas]);

    return (
        <div className="space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Empresas", to: null },
                    ]}
                />
            </CardHeader>
            <TableEmpresasContador data={filteredEmpresas} loading={loading} filters={filters} setFilters={setFilters} />
        </div>
    );
};

export default EmpresasContadorTemplate;